import { render, staticRenderFns } from "./uploadbj.vue?vue&type=template&id=a3cfcb28&scoped=true&"
import script from "./uploadbj.vue?vue&type=script&lang=js&"
export * from "./uploadbj.vue?vue&type=script&lang=js&"
import style0 from "./uploadbj.vue?vue&type=style&index=0&id=a3cfcb28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cfcb28",
  null
  
)

export default component.exports